import { useEffect, useRef, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function MaterialFile({ material }) {
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const currentUrl = useRef("");
  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
      if (currentUrl.current) URL.revokeObjectURL(currentUrl.current);
    };
  }, []);

  const load = async () => {
    setLoading(true);
    try {
      // Axios sends the session cookie and the bearer-token fallback.
      const { data } = await api.get(`/videos/${material.id}/file`, { responseType: "blob" });
      if (!mounted.current) return;
      currentUrl.current = URL.createObjectURL(data);
      setUrl(currentUrl.current);
    } catch (error) {
      let detail = "Não foi possível carregar o arquivo. Tente novamente.";
      try { detail = JSON.parse(await error.response.data.text()).detail; } catch {}
      if (mounted.current) toast.error(formatApiError(detail));
    } finally {
      if (mounted.current) setLoading(false);
    }
  };

  return (
    <div className="mt-3 space-y-3">
      <p className="text-xs text-slate-400 break-all">
        {material.filename} · {(material.size / (1024 * 1024)).toFixed(1)} MB
      </p>
      {!url && <Button type="button" disabled={loading} onClick={load}
        className="bg-amber-500 text-[#071A33] hover:bg-amber-400">
        {loading ? "Carregando arquivo…" : material.kind === "video" ? "Carregar vídeo" : "Carregar PDF"}
      </Button>}
      {url && material.kind === "video" && <video controls preload="metadata" src={url}
        aria-label={material.title} className="w-full rounded bg-black" />}
      {url && <div className="flex flex-wrap gap-4 text-sm text-amber-400">
        {material.kind === "pdf" && <a href={url} target="_blank" rel="noreferrer">Abrir PDF</a>}
        <a href={url} download={material.filename}>Baixar arquivo</a>
      </div>}
    </div>
  );
}
